// Copy of components/datePicker/index.js wired to its own Redux slice for the Payments - Beta tab.
import { memo } from "react";
import { connect } from "react-redux";

import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./DatePickerV2Beta.state";
import DatePicker from "@/components/datePicker/DatePicker";

export default memo(connect(mapStateToProps, mapDispatchToProps)(DatePicker));

export { reducer, mapStateToProps, mapDispatchToProps };
